import { render, staticRenderFns } from "./BlogView.vue?vue&type=template&id=0fdf3d62&"
import script from "./BlogView.vue?vue&type=script&lang=js&"
export * from "./BlogView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports